// simple-lazy-load
document.addEventListener('DOMContentLoaded', function() {
    // Check if IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
        //console.log('IntersectionObserver not supported - loading all images immediately');
        loadAllImages();
        return;
    }

    //console.log('Setting up lazy loading...');

    // Create the observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                //console.log('Image entering viewport:', entry.target);
                loadImage(entry.target);
                observer.unobserve(entry.target);
            }
        });
    });

    // Find all images to lazy load
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    //console.log('Found', lazyImages.length, 'images to lazy load');

    // Observe each image
    lazyImages.forEach(img => {
        observer.observe(img);
        //console.log('Observing:', img.src);
    });

    function loadImage(img) {
        const src = img.getAttribute('data-src');
        if (!src) {
            console.warn('No data-src found on image:', img);
            return;
        }
        
        try {
            img.src = src;
            img.removeAttribute('data-src');
            //console.log('Loaded image:', src);
        } catch (e) {
            console.error('Error loading image:', e);
        }
    }

    function loadAllImages() {
        document.querySelectorAll('img[data-src]').forEach(img => {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
        });
    }
});

// lazy-load-background
document.addEventListener('DOMContentLoaded', function() {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const element = entry.target;
                const imageUrl = element.getAttribute('data-background');
                
                if (imageUrl) {
                    // Preload the image
                    const img = new Image();
                    img.onload = () => {
                        element.style.backgroundImage = `url(${imageUrl})`;
                        element.classList.add('background-loaded');
                    };
                    img.src = imageUrl;
                    
                    // Stop observing after loading
                    observer.unobserve(element);
                }
            }
        });
    }, {
        rootMargin: '50px 0px',
        threshold: 0.01
    });

    // Find all elements with data-background attribute
    const lazyBackgrounds = document.querySelectorAll('[data-background]');
    lazyBackgrounds.forEach(element => {
        //console.log('Observing:', element);
        observer.observe(element);
    });
});